import React, { useState } from "react";
import {
  Grid,
  Radio,
  Button,
  Select,
  MenuItem,
  FormLabel,
  TextField,
  RadioGroup,
  FormControl,
  CircularProgress,
  FormControlLabel,
} from "@mui/material";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { validateEmail } from "../../../utils";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";

const OtpVerification = () => {
  const [data, setData] = useState<any>([]);
  const [msisdn, setMsisdn] = useState("");
  const [email, setEmail] = useState<string>("");
  const [validationErrorMessage, setValidationErrorMessage] =
    useState<string>("");
  const [action, setAction] = useState<Boolean>(false);
  const [checkBy, setCheckBy] = useState<string>("Msisdn");
  const [option, setOption] = useState<string>("0");

  const handleChange = (event: any) => {
    setCheckBy(event.target.value);
  };

  const validate = () => {
    if (msisdn === "" && email === "") {
      setValidationErrorMessage("Please provide the value");
      return false;
    }

    if (option === "3") {
      if (msisdn.trim().length < 9) {
        setValidationErrorMessage("Please enter valid Msisdn");
        return false;
      }
      return true;
    }

    if (option === "4") {
      if (!validateEmail(email.trim())) {
        setValidationErrorMessage("Please enter valid email address");
        return false;
      }
      return true;
    }

    if (option === "1") {
      if (checkBy === "Msisdn") {
        if (msisdn.trim().length < 9) {
          setValidationErrorMessage("Please enter valid Msisdn");
          return false;
        }
      } else if (checkBy === "Email") {
        if (!validateEmail(email.trim())) {
          setValidationErrorMessage("Please enter valid email address");
          return false;
        }
      }
    }

    return true;
  };

  const requestBundles = async () => {
    toast.dismiss();
    setData(null);
    if (!validate()) return;
    setAction(true);

    try {
      let url = "/dashboard/OTPVerification";

      if (msisdn) {
        url += `?SearchBy=${msisdn.trim()}&Product=${option}`;
      } else if (email) {
        url += `?SearchBy=${email.trim()}&Product=${option}`;
      }

      const res = await axiosInterceptorInstance.get(url);

      setAction(false);
      setData(null);
      const apiresponse = JSON.parse(res.data.body);

      const otpData = apiresponse.OTP;

      if (!otpData || (option == "1" && Object.keys(otpData).length === 0)) {
        toast.error("Record not found.");
        return;
      }

      setData(otpData);
    } catch (error: any) {
      setAction(false);
      toast.error(error.message);
    }
  };

  const handleSearchTerm = (e: any) => {
    if (option === "4") {
      setEmail(e.target.value);
      setValidationErrorMessage("");
      return;
    }

    if (option === "3") {
      setMsisdn(e.target.value);
      setValidationErrorMessage("");
      return;
    }

    if (checkBy === "Msisdn") {
      setMsisdn(e.target.value);
      setEmail("");
      setValidationErrorMessage("");
    }

    if (checkBy === "Email") {
      setEmail(e.target.value);
      setMsisdn("");
      setValidationErrorMessage("");
    }
  };

  const handleDropdownChange = (e: any) => {
    setOption(e.target.value);

    setMsisdn("");
    setEmail("");
    setData(null);
    setValidationErrorMessage("");
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">OTP Verification</h2>
        <div className="boxInner">
          <FormControl fullWidth>
            <FormLabel className="label">Select Product</FormLabel>
            <Select value={option} onChange={handleDropdownChange} displayEmpty>
              <MenuItem value="0">Choose Product</MenuItem>
              <MenuItem value="1">THM/NOW/RWG</MenuItem>
              <MenuItem value="3">THA</MenuItem>
              <MenuItem value="4">THCC/THRCC</MenuItem>
            </Select>
          </FormControl>

          {(option === "3" || option == "4") && (
            <Grid container spacing={2} style={{ marginTop: "20px" }}>
              <Grid item xs={8}>
                <TextField
                  className="formControl"
                  variant="outlined"
                  label={option === "3" ? "MSISDN" : "Email"}
                  value={option === "3" ? msisdn : email}
                  onChange={(e) => handleSearchTerm(e)}
                  inputProps={
                    option === "3" ? { maxLength: 20 } : { maxLength: 50 }
                  }
                />
              </Grid>
              <Grid item xs={4}>
                {!action && (
                  <Button
                    onClick={requestBundles}
                    className="dButton dButton2"
                    variant="contained"
                  >
                    Search
                  </Button>
                )}
                {action && (
                  <Button className="dButton dButton2" variant="contained">
                    <CircularProgress color="inherit" size={30} />
                  </Button>
                )}
              </Grid>
            </Grid>
          )}

          {option === "1" && (
            <>
              <FormControl style={{ marginTop: "20px" }}>
                <FormLabel
                  id="demo-radio-buttons-group-label"
                  className="label"
                >
                  Search By
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  row
                  value={checkBy}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="Msisdn"
                    control={<Radio />}
                    label="Msisdn"
                  />
                  <FormControlLabel
                    value="Email"
                    control={<Radio />}
                    label="Email"
                  />
                </RadioGroup>
              </FormControl>

              <Grid container spacing={2} style={{ marginTop: "10px" }}>
                <Grid item xs={8}>
                  <TextField
                    className="formControl"
                    variant="outlined"
                    label={checkBy === "Msisdn" ? "MSISDN" : "Email"}
                    value={checkBy === "Msisdn" ? msisdn : email}
                    onChange={(e) => handleSearchTerm(e)}
                    inputProps={
                      checkBy === "Msisdn"
                        ? { maxLength: 20 }
                        : { maxLength: 50 }
                    }
                  />
                </Grid>
                <Grid item xs={4}>
                  {!action && (
                    <Button
                      onClick={requestBundles}
                      className="dButton dButton2"
                      variant="contained"
                    >
                      Search
                    </Button>
                  )}
                  {action && (
                    <Button className="dButton dButton2" variant="contained">
                      <CircularProgress color="inherit" size={30} />
                    </Button>
                  )}
                </Grid>
              </Grid>
            </>
          )}

          <div style={{ color: "red" }}>{validationErrorMessage}</div>

          {(option === "1" || option === "4") && data && (
            <table className="customTable OTPTable">
              <thead>
                <tr>
                  <th>OTP</th>
                  <th>Date</th>
                  <th>AppName</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item: any, index: any) => (
                  <tr key={index}>
                    <td style={{ textTransform: "uppercase" }}>{item.OTP}</td>
                    <td>
                      {new Date(item.otpGeneration_date).toLocaleString()}
                    </td>
                    <td style={{ textTransform: "uppercase" }}>
                      {item.AppName}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {option === "3" && data && (
            <table className="customTable OTPTable">
              <thead>
                <tr>
                  <th>OTP</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ textTransform: "uppercase" }}>{data.pin}</td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default OtpVerification;
